<template>
    <div>
	<div class="page-header clear-filter" filter-color="black">
        <nav class="navbar navbar-expand-lg fixed-top navbar-light bg-dark">
		<div class="container">
			<a class="navbar-brand" href="#">E-Portfolio</a>
			<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navigation" aria-controls="navigation" aria-expanded="false" aria-label="Toggle navigation">
				<span class="navbar-toggler-bar bar1"></span>
				<span class="navbar-toggler-bar bar2"></span>
				<span class="navbar-toggler-bar bar3"></span>
			</button>
			<div class="collapse navbar-collapse menu" id="navigation">
				<ul class="navbar-nav mr-auto mt-2 mt-lg-0">
					<li class="nav-item">
						<a class="nav-link" href="#APropos">A PROPOS</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" href="#Experiences">MES EXPERIENCES</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" href="#Projets">MES PROJETS</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" href="#Competences">MES COMPETENCES</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" href="#Certificats">MES CERTIFICATIONS</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" href="#Loisirs">MES LOISIRS</a>
					</li>

				</ul>
			</div>
		</div>
	</nav>
            <parallax class="page-header-image"
                      style="background-image:url('img/header.jpg')">
            </parallax>
            <div class="container">
                <div class="content-center brand">
                    <div class="photo-container">
                        <img :src="getImg(data.profil.img)" alt="Photo" />
                    </div>
                    <h3 class="title"> {{ data.profil.nom }} </h3>
                    <p class="category"> {{ data.profil.metier }} <br /> {{ data.profil.entreprise }} </p>
                    <Coordonnees :coord="data.profil.coordonnees" />
                </div>
            </div>
        </div>
        <div class="section" id="app">
            <APropos :description="data.profil.description" id="APropos" />
            <Experiences :exp="data.experiences" id="Experiences" />
            <Projets :projets="data.projets" :categorie_projets="data.categorie_projet" :img_projets="data.img_proj" id="Projets" />
            <Competences :competences_hard="data.competences_hard" :competences_soft="data.competences_soft" id="Competences" />
            <Certificats :certificat="data.diplome" id="Certificats" />
            <Loisirs :loisirs="data.loisirs" id="Loisirs" />
            <Pieds />
        </div>
    </div>
</template>

<script>
    import { Parallax } from '@/components';
    import APropos from "./pages/APropos.vue";
    import Coordonnees from "./pages/Coordonnees.vue";
    import Experiences from "./pages/Experiences.vue";
    import Projets from "./pages/Projets.vue";
    import Competences from "./pages/Competences.vue";
    import Certificats from "./pages/Certificats.vue";
    import Loisirs from "./pages/Loisirs.vue";
    import Pieds from "./pages/Pieds.vue";

    export default {
        name: "index",
        bodyClass: "index-page",
        components: {
            Parallax,
            APropos,
            Coordonnees,
            Experiences,
            Projets,
            Competences,
            Certificats,
            Loisirs,
            Pieds
        },
        props: {
            data: {
                type: Object,
                required: true,
            },
        },
        methods: {
            getImg(img) {
                return require('../public/img/' + img);
            }
        }
    };

    document.addEventListener("DOMContentLoaded", function() {
        var navbarToggler = document.querySelector(".navbar-toggler");
        var navigation = document.querySelector("#navigation");

        navbarToggler.addEventListener("click", function() {
            if (navigation.style.transform === "translate3d(0, 0, 0)") {
                navigation.style.transform = "translate3d(100%, 0, 0)";
            } else {
                navigation.style.transform = "translate3d(0, 0, 0)";
            }
        });

    navbarToggler.addEventListener("click", function() {
        if (navigation.style.display === "block") {
            navigation.style.display = "none";
        } else {
            navigation.style.display = "block";
        }
    });

window.addEventListener("resize", function() {
    if (window.innerWidth > 991) {
        navigation.style.transform = "";
            navigation.style.display = "";

    } else {
        navigation.style.transform = "translate3d(100%, 0, 0)";
            navigation.style.display = "none";
    }
});

        function closeMenuOnItemClick() {
            var navItems = document.querySelectorAll("#navigation .nav-item .nav-link");

            navItems.forEach(function(navItem) {
                navItem.addEventListener("click", function() {
                    if (window.innerWidth <= 991) {
                        navigation.style.transform = "translate3d(100%, 0, 0)";
                    }
                });
            });
        }

        closeMenuOnItemClick();
    });
</script>

<style scoped lang="scss">

#navigation {
	height: auto !important;
	background-color: #343a40 !important;
	top: 60px;
	width: 100% !important;
	-webkit-transform: translate3d(0, 0, 0) ;
	transform: translate3d(0, 0, 0) ;
}

#navigation:before {
	background: #343a40 !important;
}

.photo-container {
    a:focus {
        outline: none;
    }
    img {
        width: 200px;
        height: 200px;
        border-radius: 50%;
        display: inline-block;
    }
}

img {
    max-width: 100%;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding: 0px;
}

.section {
  height: 100%;
}
</style>
